/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type EnumPatientContactType = "email" | "fax" | "inapp" | "sms" | "voice" | "whatsapp" | "%future added value";
export type ChatInput_Patient = {
    readonly _id: string;
    readonly createdAt: unknown | null;
    readonly updatedAt: unknown | null;
    readonly balance: number | null;
    readonly name: string | null;
    readonly firstname: string | null;
    readonly lastname: string | null;
    readonly doNotContact: boolean | null;
    readonly contact: ReadonlyArray<{
        readonly active: boolean | null;
        readonly type: EnumPatientContactType | null;
        readonly value: string | null;
        readonly archived: boolean | null;
    } | null> | null;
    readonly subscribers: ReadonlyArray<{
        readonly subscribed: boolean | null;
        readonly user: string | null;
    } | null> | null;
    readonly " $fragmentRefs": FragmentRefs<"ButtonChatMessageSubmit_Patient">;
    readonly " $refType": "ChatInput_Patient";
};
export type ChatInput_Patient$data = ChatInput_Patient;
export type ChatInput_Patient$key = {
    readonly " $data"?: ChatInput_Patient$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"ChatInput_Patient">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ChatInput_Patient",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "_id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "balance",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstname",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastname",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "doNotContact",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PatientContact",
      "kind": "LinkedField",
      "name": "contact",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "active",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "value",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "archived",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PatientSubscribers",
      "kind": "LinkedField",
      "name": "subscribers",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "subscribed",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "user",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ButtonChatMessageSubmit_Patient"
    }
  ],
  "type": "Patient",
  "abstractKey": null
};
(node as any).hash = '686081a7061f00fc00764acbbc744257';
export default node;
